module.exports = __webpack_public_path__ + "media/images/flag/in-1a2584f93bf1b962707fd5687aa39488.jpg";